import React from 'react';
import styles from './AdminDashboardProducts.module.scss';
import AdminProductGrid from '../../../../components/layout/AdminProductGrid/AdminProductGrid';
import AdminProductCard from '../../../../components/AdminProductCard/AdminProductCard';
import { Skeleton } from '@tcc-online/common-components';
import AdminProductType from '../../../../types/AdminProductType';

type AdminDashboardProductsProps = {
    products: AdminProductType[];
    isLoading?: boolean;
};

const skeletonComponent = Array.from(new Array(4), (_, index: number) => (
    <Skeleton height={400} key={index} className={styles.skeleton} />
));

export default function AdminDashboardProducts(
    props: AdminDashboardProductsProps,
) {
    const { products, isLoading } = props;

    return (
        <AdminProductGrid>
            {!isLoading
                ? products.map((product: AdminProductType) => (
                      <AdminProductCard
                          key={product.id}
                          name={product.name}
                          icon={product.internalName}
                          productId={product.id}
                          recentProjects={product.recentProjects}
                      />
                  ))
                : skeletonComponent}
        </AdminProductGrid>
    );
}
